<!--台账设备树
可以单选的树形图，针对台账设备树，根据type字段决定图标
双击展开收起
可以配置组能不能选中
-->
<template>
	<baseTree ref="treeBean" :dataList="dataList" :groupCheckAble="groupCheckAble" class="treeBody" :autoSelectMethod="autoSelectMethod"
	 :typeImgNameList="typeImgNameList" :getTypeImgIndex="getTypeImgIndex" :isGroup="isGroup" :isSameItem="isSameItem"
	 :baseTreeStyle="{}" @checkItem="$emit('checkItem', $event)" :getIDMethod="getIDMethod" :stateShowAble="stateShowAble">
	</baseTree>
</template>

<script>
	import baseTree from '@/components/module/tree/baseTree.vue'
	import imageView from '@/components/module/universal/imageView.vue'
	export default {
		components: {
			baseTree,
			imageView,
		},
		props: {
			//数据源，可查看设备树或者啥的
			dataList: {
				type: Array,
				required: true,
			},
			//默认选中的方法,接收到数据源的时候，会递归设备树，然后根据这个方法找到第一个符合条件的项，设置为选中项，但是会根据是否允许选中单位来做过滤，如果不允许选中单位组，返回true也无效
			autoSelectMethod: {
				type: Function,
				default (item, index) {
					//默认是找到第一个设备
					return item.entityName == 'AppEquipmentArchives'
				}
			},
			//组是否可以选中，如果可以选中的话，点击会触发点击事件
			groupCheckAble: {
				type: Boolean,
				default: false
			},
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
			stateShowAble: {
				type: Function,
				default (item, index) {
					return this.isGroup(item) && !isempty(this.getNextMethod(item))
				}
			}
		},
		data() {
			return {
				typeImgNameList: [
					'tree/node_unit.png', 'tree/node_class.png', 'tree/node_file.png',
					'tree/node_unit_select.png', 'tree/node_class_select.png', 'tree/node_file_select.png'
				],
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			isGroup(item) {
				return item.entityName == 'AppClassType' || (item.unitNo != undefined && item.id != undefined)
			},
			getIDMethod(item) {
				return item.id
			},
			isSameItem(item, nowItem) {
				if (nowItem == undefined || item == undefined) {
					return item == nowItem
				}
				return item.id == nowItem.id && item.type == nowItem.type
			},
			getTypeImgIndex(item) {
				var treeB = this.$refs.treeBean
				if (treeB == undefined) {
					treeB = {}
				}
				var nowData = treeB.nowCheckItem ? treeB.nowCheckItem : this.multiSelect ? [] : {}
				if (this.multiSelect) {
					if (nowData.includes(item)) {
						if (!this.isGroup(item)) {
							return 5
						}
						if (!isempty(item.unitid)) {
							return 3
						}
						return 4
					} else {

						if (!this.isGroup(item)) {
							return 2
						}
						if (!isempty(item.unitid)) {
							return 0
						}
						return 1
					}
				} else {
					if (this.isSameItem(item, nowData)) {

						if (!this.isGroup(item)) {
							return 5
						}
						if (!isempty(item.unitid)) {
							return 3
						}
						return 4
					} else {

						if (!this.isGroup(item)) {
							return 2
						}
						if (!isempty(item.unitid)) {
							return 0
						}
						return 1
					}
				}
			},
			setNowCheckItem(item) {
				this.$refs.treeBean.nowCheckItem = item
			}
		}
	}
</script>

<style scoped>
</style>
